/**
 * Файл накладной, ожидающий отправки. `File` не сериализуется, а аргументы
 * мутации RTK Query лежат в Redux-состоянии: поэтому в аргументе — только
 * токен, а сам файл на время запроса хранится здесь, в памяти вкладки, вне
 * стора. Запись снимается, когда запрос закончился (успехом или отказом).
 */
const pending = new Map<string, File>()

export function stashUpload(token: string, file: File): void {
  pending.set(token, file)
}

export function takeUpload(token: string): File | undefined {
  return pending.get(token)
}

export function releaseUpload(token: string): void {
  pending.delete(token)
}
